import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { STATUS_SHIPMENT_TO_BE_SELF_COLLECTED } from '../constants/orderStatuses'
import { getPickupDisplayName } from '../utils/pickupName'
import { ArrowRightIcon } from './Icons/ArrowRightIcon'
import { MapPinIcon } from './Icons/MapPinIcon'
import { XIcon } from './Icons/XIcon'
import { PICKUP_CHIP_ANCHOR_ID } from '../constants/pickup'

export function PickupReadyNotice({ order }) {
    const { t } = useTranslation()
    const [dismissed, setDismissed] = useState(false)

    if (dismissed) return null
    if (order?.shipping_status !== STATUS_SHIPMENT_TO_BE_SELF_COLLECTED) return null
    if (order?.click_and_collect_metadata == null) return null

    const name = getPickupDisplayName(order.click_and_collect_metadata, t)
    const message = t('pickupActionChip.readyNotice.message', { pickup_name: name })

    const handleJump = (e) => {
        e.preventDefault()
        const target =
            document.getElementById(PICKUP_CHIP_ANCHOR_ID) ||
            document.querySelector('nav[aria-label="Progress"]')
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    return (
        <div
            className="my-4 p-3 bg-blue-50 border border-blue-200 rounded-md flex items-center gap-3"
            role="region"
            aria-label={t('pickupActionChip.readyNotice.regionLabel')}
        >
            <MapPinIcon className="h-5 w-5 text-blue-600 shrink-0" aria-hidden="true" />
            <span className="flex-1 text-sm text-gray-800 min-w-0 break-words">
                {message}{' '}
                <a
                    href={`#${PICKUP_CHIP_ANCHOR_ID}`}
                    onClick={handleJump}
                    className="text-blue-600 hover:text-blue-700 font-medium min-h-[44px] inline-flex items-center rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
                >
                    {t('pickupActionChip.readyNotice.jumpLink')} <ArrowRightIcon className="ml-1 h-3 w-3" />
                </a>
            </span>
            <button
                type="button"
                onClick={() => setDismissed(true)}
                aria-label={t('pickupActionChip.readyNotice.dismissAriaLabel')}
                className="text-gray-500 hover:text-gray-700 hover:bg-blue-100 rounded-md min-h-[44px] min-w-[44px] flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
            >
                <XIcon className="h-4 w-4" />
            </button>
        </div>
    )
}
